import './user-overview.scss';
import UserOverview from './user-overview';

export default UserOverview;
